module.exports = __webpack_public_path__ + "static/default/img/logo.d3859226.png";